module.exports = __webpack_public_path__ + "img/xcx.ffa74d50.png";